import { NavLink } from "react-router-dom";
import { memo } from "react";
import { classNames, transformRoute } from "helpers";
import { Routes as CalculationRoutes } from "ui/modules/calculation/navigation";
import { ReactSVG } from "react-svg";
import { CalculationTabMenuProps } from "./types";

const TabMenu: React.FC<CalculationTabMenuProps> = (props) => {
  const { calculationId } = props;

  return (
    <div className="flex border-b border-slate-200 bg-white">
      <NavLink
        to={transformRoute(CalculationRoutes.CalculationDetailPageRouter, {
          calculationId,
        })}
      >
        {({ isActive }) => (
          <div
            className={classNames(
              "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-3 hover:text-sky-600",
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600"
            )}
          >
            <ReactSVG
              src="/media/icons/info.svg"
              className={classNames(
                "w-5 h-5 group-hover:stroke-sky-600",
                isActive ? "stroke-sky-600" : "stroke-slate-500"
              )}
            />
            Detalji kalkulacije
          </div>
        )}
      </NavLink>
    </div>
  );
};

export default memo(TabMenu);
